import React from 'react';
import './App.css';
import Jobs from './features/Jobs';

function App() {
  return (
    <div className="App">
      <Jobs />
    </div>
  );
}

export default App;
